import { render, staticRenderFns } from "./user_level_list.vue?vue&type=template&id=4abfe4fe"
import script from "./user_level_list.vue?vue&type=script&lang=js"
export * from "./user_level_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports